import * as React from "react"
import {Box} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import {useMatchersSkusForm} from "../../@hooks";


export default function MatchersSKUsDrawerAvailable({ type, label }) {
	const { localValue, handleChange } = useMatchersSkusForm(type)

	const icon = localValue ? "check-to-slot" : "xmark-to-slot"
	const color = localValue ? "success.main" : "error.main"

    return <Box>
		<ButtonIconSeeker
			icon={icon}
			iconProps={{ color }}
			onClick={() => handleChange(!localValue)}
		/> {label}
	</Box>
}
